import { render, staticRenderFns } from "./AddnewChoose.vue?vue&type=template&id=65b1ff85&scoped=true"
import script from "./AddnewChoose.vue?vue&type=script&lang=js"
export * from "./AddnewChoose.vue?vue&type=script&lang=js"
import style0 from "./AddnewChoose.vue?vue&type=style&index=0&id=65b1ff85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1ff85",
  null
  
)

export default component.exports